module.exports = __webpack_public_path__ + "img/qostanay2.1feb9517.jpg";